import { observer } from 'mobx-react';
import { FC } from 'react';

import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';

import { ContactManagementStore } from '../stores/contact-management.store';

export const ContactManagementPage: FC = provide({
    singletons: [ContactManagementStore],
})(
    observer(() => {
        const [{ data, basename, source }] = useDependencies(ContactManagementStore);

        return (
            <Loader
                className="w-100"
                data={data}
                src={source}
                basename={basename}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
